export enum TOrigin {
	External = 1,
	Painel = 2,
}